// NOTE: Need to add Collapsible content
import PropTypes from 'prop-types';
import moment from 'moment';
import { Box, makeStyles } from '@material-ui/core';

import { isNativeDetected } from '~/utils/mobileDetect';
import { getUnitDisplay, convertValue } from '~/utils';
import { Regular14 } from '~/components/Typography';
import Attachment from '~/components/Attachment';
import { formatMentionText } from '~/components/UserMention/utils';
import CollapsibleContent from '~/components/CollapsibleContent';
import { FEED_ITEM_TYPES, FEED_ITEM_TIME_FORMAT } from '~/constants/feed';

const PAGE_NAME = 'TracesMemoFeedItem';

const useStyles = makeStyles(theme => ({
  message: {
    lineHeight: '20px',
  },
  container: {
    marginBottom: 4,
    lineHeight: '20px',
  },
  label: {
    color: theme.palette.primary.text6,
  },
}));

const TracesMemoFeedItem = ({
  feedItem: {
    context: {
      [FEED_ITEM_TYPES.TRACES_MEMO]: { body, attachment = {}, bitDepth, holeDepth, timestamp },
    },
    mentioned_users: mentionedUsers,
  },
}) => {
  const classes = useStyles();

  const lengthUnit = getUnitDisplay('length');
  const bitDepthConverted = convertValue(+bitDepth, 'length', 'ft');
  const holeDepthConverted = convertValue(+holeDepth, 'length', 'ft');

  const attachmentUrl = attachment?.signed_url || attachment?.url;
  const attachmentName = attachment?.file_name || attachment?.name;

  return (
    <Box whiteSpace="pre-wrap">
      {body && (
        <CollapsibleContent>
          <Regular14
            className={classes.message}
            data-testid={`${PAGE_NAME}_message`}
            variant="body1"
          >
            {formatMentionText(body, mentionedUsers, isNativeDetected)}
          </Regular14>
        </CollapsibleContent>
      )}

      <Box mt={1} mb={1}>
        <Regular14 data-testid={`${PAGE_NAME}_Time`} className={classes.container}>
          <span className={classes.label}>Time:&nbsp;</span>
          {moment.unix(timestamp).format(FEED_ITEM_TIME_FORMAT)}
        </Regular14>

        {Number.isFinite(holeDepth) && (
          <Regular14 data-testid={`${PAGE_NAME}_HoleDepth`} className={classes.container}>
            <span className={classes.label}>Hole Depth:&nbsp;</span>
            {`${holeDepthConverted} ${lengthUnit}`}
          </Regular14>
        )}

        {Number.isFinite(bitDepth) && (
          <Regular14 data-testid={`${PAGE_NAME}_BitDepth`} className={classes.container}>
            <span className={classes.label}>Bit Depth:&nbsp;</span>
            {`${bitDepthConverted} ${lengthUnit}`}
          </Regular14>
        )}
      </Box>

      {attachment && attachmentUrl && (
        <Attachment
          attachmentUrl={attachmentUrl}
          fileName={attachmentName}
          attachmentSize={attachment.size}
          size="medium"
        />
      )}
    </Box>
  );
};

TracesMemoFeedItem.propTypes = {
  feedItem: PropTypes.shape({
    context: PropTypes.shape({
      [FEED_ITEM_TYPES.TRACES_MEMO]: PropTypes.shape({
        body: PropTypes.string.isRequired,
        attachment: PropTypes.shape({
          url: PropTypes.string,
          size: PropTypes.number,
        }),
        bitDepth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        holeDepth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      }).isRequired,
    }).isRequired,
    mentioned_users: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};

export default TracesMemoFeedItem;
